<div class="naming-container">
  <label class="label">Chart Content Summary</label>
  <div class="summary" *ngFor="let summary of summaryData">
    <div class="summary-label">{{ summary.title }}:</div>
    <div class="data">
      <span *ngFor="let data of summary.data; let i = index">
        <ng-container *ngIf="i <= 5 && i + 1 !== summary.data.length"
          >{{ data }},
        </ng-container>
        <ng-container *ngIf="i <= 5 && i + 1 === summary.data.length">{{
          data
        }}</ng-container>
      </span>
      <ng-container *ngIf="summary.data.length > 6"
        >and {{ summary.data.length - 6 }} more...</ng-container
      >
    </div>
  </div>
  <div>
    <va-period-filter
      [periodData]="yearTypeData"
      [filterWidthVariation]="type === 'Timeseries' ? 3 : 1"
      (onApply)="saveChartsYearType($event)"
      [dataAvailable]="periodsWithAvailableData"
    ></va-period-filter>
  </div>
  <!-- <div class="summary" *ngIf="type !== 'Comparison'">
          <div class="summary-label">Date Period:</div>
          <div class="data">{{ YearTypeData.start }}-{{ YearTypeData.end }}</div>
        </div> -->
  <!-- <div class="filter" *ngIf="type === 'line'">
    <div class="label">Estimates:</div>
    <div>
      <app-estimates-filter
        [selectedEstimates]="createPeriod"
        [createChart]="true"
        (onChange)="setCreateChartPeriod($event)"
      ></app-estimates-filter>
    </div>
  </div> -->
  <!-- Revision Period Filter -->
  <div
    id="revisionsperiod-filter"
    class="filter revision-filter-container"
    *ngIf="type === 'line'"
  >
    <!-- <div class="label">Revision History:</div> -->
    <!-- <div>
      <nz-select
        nzPlaceHolder="Date"
        class="select"
        style="width: 100px"
        [(ngModel)]="revision"
        (ngModelChange)="saveRevisionPeriod($event)"
        [nzDropdownClassName]="'select-dropdown-style'"
      >
        <ng-container *ngFor="let period of revisionPeriodList">
          <nz-option
            [nzValue]="period.value"
            [nzLabel]="period.label"
          ></nz-option>
        </ng-container>
      </nz-select>
    </div> -->
    <app-revision-period-select
      [selectedRevision]="'12m'"
      (onChange)="saveRevisionPeriod($event)"
      [createChart]="'true'"
    ></app-revision-period-select>
  </div>

  <!-- <div class="period-filter" *ngIf="type === 'Comparison'" class="filter">
    <div class="label">Period:</div>
    <app-charts-year-type-filter
      [filterData]="filterData"
      chartType="normalChart"
      createComp="true"
      [yearTypeData]="yearTypeData"
      (saveYearType)="saveChartsYearType($event)"
    ></app-charts-year-type-filter>
  </div>

  <div class="period-filter" *ngIf="type === 'Timeseries'" class="filter">
    <div class="label">Period Range:</div>
    <app-charts-year-type-filter
      [filterData]="filterData"
      chartType="TimeSeries"
      createComp="true"
      [yearTypeData]="yearTypeData"
      (saveYearType)="saveChartsYearType($event)"
    ></app-charts-year-type-filter>
  </div> -->

  <div class="chart-name">
    <label>Chart Name:</label>
    <input
      nz-input
      #name
      nzSize="small"
      placeholder="Enter Chart Name"
      [(ngModel)]="ChartName"
      (keyup)="onChangeChartName()"
      maxlength="100"
      [ngClass]="[chartNameError ? 'err-border' : '']"
    />
    <span class="error-color chart-name-error" [hidden]="chartNameError === ''">
      <va-icon size="small" name="exclamation-triangle" class="va-icon"></va-icon>
      {{ chartNameError }}</span
    >
  </div>
</div>
